import React, { createContext, useContext, useState, useEffect } from 'react';

import CompanyService from '../services/company.service';
import { Company, CompanyContextType } from '../types/Company.type';

// Module-level cache — survives unmount/remount cycles
let companiesCache: Company[] | null = null;
let companiesFetchPromise: Promise<Company[]> | null = null;

export const clearCompaniesCache = () => {
  companiesCache = null;
  companiesFetchPromise = null;
};
/**
 * Company context
 * {
    "RecId": 124,
    "OrgRecId": 1,
    "SolutionsOrgID": null,
    "RegionID": null,
    "LocationRecId": 0,
    "CompanyName": "Absolute Automotive Credit",
    "LegalName": "Absolute Automotive Credit",
    "QBName": "Absolute Auto",
    "EffectiveDate": "2021-03-17",
    "Status": "Active",
    "Address": "1569 Route 9",
    "City": "Fort Edward",
    "State": "NY",
    "Zip": "12828",
    "BHPHName": null,
    "BHPHAddress": null,
    "BHPHCity": null,
    "BHPHState": null,
    "BHPHZip": "",
    "Phone": "(518) 745-0316",
    "Fax": null,
    "ContactName": "W. John Smith",
    "ContactEmail": null,
    "ContactPhone": null,
    "ContactPhoneExt": null,
    "AcctNum": null,
    "Longitude": null,
    "Laditude": null,
    "GeoLocation": null,
    "TimeZoneRecId": null,
    "TimeZone": "5",
    "Daylight": null,
    "Email_From": null,
    "Email_From_Address": null,
    "GettingHere": null,
    "MgrRecId": null,
    "Intro": null,
    "MainMsg": null,
    "Invite": null,
    "DealerNum": null,
    "CompanyURL": null,
    "Def_APR": "0.00",
    "Def_PMT": "0.00",
    "Def_Term": 0,
    "LateChgUsed": false,
    "LateChgPerPmt": false,
    "LateChgGrace": false,
    "LateChgRate": "0.00",
    "LateChgMax": "0.00",
    "LateChgMin": "0.00",
    "StockOpt": null,
    "UseFlDoc": false,
    "UseTXTax": false,
    "UseTXInvTax": false,
    "IntType": "Simple",
    "UseAcctNum": false,
    "LotType": null,
    "LateGraceDays": 0,
    "NSFFee": "0.00",
    "CompanyLogo": null,
    "HaveLogo": false,
    "NextSkNum": "0",
    "DefSchedule": null,
    "CompanyEmailPassword": null,
    "EmailMode": null,
    "TextMode": null,
    "Robo": null,
    "TestDriveRoute": null,
    "AcctToken": null,
    "AcctTokenTest": null,
    "RecNote": null,
    "RoboPhoneNum": null,
    "ShortName": "Absolute",
    "CkAcctDefault": 0,
    "DPAcctDefault": 0,
    "MandrillKey": null,
    "EmailServer": null,
    "EmailISSSL": false,
    "EmailISHTML": false,
    "EmailPort": null,
    "EmailIssetup": false,
    "TwilioURL": null,
    "TwilioSID": null,
    "TwilioToken": null,
    "TwilioPhoneNumber": null,
    "TwilioIsSetup": false,
    "TwilioRobocallFallbackMsg": null,
    "TwilioReplyDefault": null,
    "BDCTwilioURL": null,
    "BDCTwilioSID": null,
    "BDCTwilioToken": null,
    "BDCPhoneNumber": null,
    "BDCTwilioIsSetup": false,
    "UnitReviewMths": "February,May,August,November",
    "lRes2": null,
    "lRes3": null,
    "lRes4": null,
    "lRes5": null,
    "lRes6": null,
    "lRes7": null,
    "lRes8": null,
    "lRes9": null,
    "lRes10": null,
    "More1": false,
    "More2": false,
    "More3": false,
    "More4": false,
    "More5": false,
    "More6": false,
    "More7": false,
    "More8": false,
    "More9": false,
    "More10": false,
    "Moretype1": null,
    "Moretype2": null,
    "Moretype3": null,
    "Moretype4": null,
    "Moretype5": null,
    "Moretype6": null,
    "Moretype7": null,
    "Moretype8": null,
    "Moretype9": null,
    "Moretype10": null,
    "BegDNum": null,
    "BegTNum": null,
    "BegDAmt": null,
    "BegTAmt": null,
    "DefDown": null,
    "DefPDown": null,
    "County": null,
    "MgrSig": null,
    "OwnerSig": null,
    "CRName": null,
    "CRAgency": null,
    "DefRFC": null,
    "UsePrintServer": false,
    "CureType": null,
    "DyLogo": null,
    "MAFC_LID": null,
    "MAFC_MID": null,
    "MAFC_Loc": null,
    "Def_SP": null,
    "WebLocID": null,
    "DefRCL": null,
    "EcomOn": false,
    "DefBankAcctID": null,
    "LocType": null,
    "OneCheck": null,
    "TwoCheck": null,
    "GLBA": null,
    "CIO_ID": null,
    "Abv_Name": null,
    "Signer": null,
    "PrintDir": false,
    "ShowDir": true,
    "RC_Extention": null,
    "Code3": "AAC",
    "cbc_user_id": null,
    "cbc_user_pwd": null,
    "cbc_cus_id": null,
    "cbc_exp_date": null,
    "cbc_url": null,
    "Ltaxon": null,
    "CompCode": null,
    "sigma_host_url_production": "https://mysigmapayments.net",
    "sigma_host_url_test": "https://preprod.mysigmapayments.net",
    "sigma_host_return_url_production": "http://50.97.93.212/autostart_dealer",
    "sigma_host_return_url_test": "http://50.97.93.212/autostart_dealer",
    "sigma_token_production": "",
    "sigma_token_test": "",
    "sigma_company_id_production": 0,
    "sigma_company_id_test": 0,
    "sigma_test_mode": true,
    "paypros_token_production": "",
    "paypros_token_test": "",
    "paypros_dealer_return_url_production": "",
    "paypros_dealer_return_url_test": "",
    "paypros_portal_return_url_production": "",
    "paypros_portal_return_url_test": "",
    "paypros_test_mode": true,
    "passtime_warning_days": 4,
    "passtime_emergency_days": 2,
    "region": null,
    "ShowBank": false,
    "ActiveCompany": true,
    "InDefault": false,
    "SalesGoal": null,
    "DownType": null,
    "ManLocation": null,
    "JakcJar": null,
    "GLComp": null,
    "UsePayProsIFrame": false,
    "paypros_Token_Retail": null,
    "Logo300by90": null,
    "CreditPullActive": false,
    "CreditPullCompany": null,
    "AllowVinHistory": false,
    "AllowVinOptions": false,
    "BDCEmail": null,
    "BDCEmailName": null,
    "ContactCellPhone": null,
    "DealerEIN": null,
    "DealerDOB": null,
    "DealerSSN": null,
    "DealerNotes": null,
    "DealerDLNum": null,
    "DealerDLState": null,
    "DealerDLExp": null,
    "DealerDLImage": null,
    "ActiveLPNum": 351,
    "ActiveLPLoanAllowance": null,
    "ActiveLPLoanBalance": "2623550.94",
    "ActiveLPPmtDue": null,
    "AcitveLPAvailable": "456449.06",
    "ActiveFPAllowance": null,
    "ActiveFPNum": 0,
    "AcitveFPBalance": null,
    "ActiveFPWBalance": null,
    "ActiveFPPmtDue": null,
    "ActiveFPAvailable": null,
    "NumPend": 0,
    "NumRPend": 0,
    "FPLimit": "400000.00",
    "FPWLimit": "0.00",
    "FPAdvRate": "90.00",
    "FPMaxAddCost": "0.00",
    "FPAutoAddCost": "0.00",
    "FPYearLimit": 12,
    "FPMilesLimit": 130000,
    "LPYearLimit": 12,
    "LPMilesLimit": 130000,
    "FPIntRate": "12.50",
    "FPWRate": null,
    "FPFee": "50.00",
    "FPGPSFee": "0.00",
    "FPLateFeeRate": "1.00",
    "FPLateFeeGrace": 0,
    "FPPrintDay": 1,
    "FPDueDay": 10,
    "LPLimit": "3080000.00",
    "TieredLPFee": true,
    "LPFee": "80.00",
    "LPRate1": "15.25",
    "LPRate2": null,
    "LPRate3": null,
    "LPRate": null,
    "LPPrintDay": null,
    "LPDueDay": null,
    "DefaultTier": 1,
    "FundingDays": "Wednesday",
    "FundDOMMin1": 1,
    "FundDOMMin2": 16,
    "FundDOMMax1": 15,
    "FundDOMMax2": 31,
    "LPPrintDay1": 5,
    "LPPrintDay2": 20,
    "LPDueDay1": 10,
    "LPDueDay2": 25,
    "LPCostMinRate1": "1.00",
    "LPCostMinRate2": null,
    "LPCostMinRate3": null,
    "LPCostMaxRate1": "90.00",
    "LPCostMaxRate2": null,
    "LPCostMaxRate3": null,
    "LPCostMaxRate": "90.00",
    "LPLeaseMaxRate": null,
    "LPMaxAddCost": "500.00",
    "LPAutoAddCost": "500.00",
    "LPComment": null,
    "FpComment": null,
    "LPLateFeeRate": "1.00",
    "LPLateFeeGrace": null,
    "LPRepoSwapFee": "50.00",
    "FloorplanON": false,
    "CreditLineON": true,
    "VariRate": false,
    "RefiSwapOn": false,
    "LPMaxTerm": 48,
    "TermFundBaseLimit": "N/A",
    "TermBaseBreak": null,
    "FundBaseBreak": null,
    "BAcvLimit": null,
    "BMatchMinus": null,
    "AAcvLimit": null,
    "AMatchMinus": null,
    "ShowCar": null,
    "ShowWRT": null,
    "UseMileAdj": false,
    "UseRegionADj": false,
    "FP_NMTD": 0,
    "FP_NYTD": 0,
    "FP_NITD": 0,
    "FP_NBILLNEXT": null,
    "FP_AMTMTD": null,
    "FP_AvgMTD": null,
    "FP_AvgYTD": null,
    "FP_AVGITD": null,
    "FP_BILLNEXT": null,
    "FPNPend": 0,
    "FPAPend": null,
    "FPAWPend": null,
    "LastFundedDateFP": null,
    "LastFundedTotalFP": null,
    "LastFundedNumFP": null,
    "LastBilledNumFP": null,
    "LastBilledTotalFP": null,
    "LastBilledDateFP": null,
    "LastPaidDateFP": null,
    "LastPaidTotalFP": null,
    "LastPaidNumFP": null,
    "LastFundedDateLP": "2024-10-10",
    "LastFundedTotalLP": "39525.00",
    "LastFundedNumLP": 3,
    "LastPaidDateLP": null,
    "LastPaidTotalLP": null,
    "LastPaidNumLP": null,
    "LastBilledDateLP": "2024-10-05",
    "LastBilledTotalLP": "50571.91",
    "LastBilledNumLP": 136,
    "DMSProvider": null,
    "GPSProvider": null,
    "FPAvgYear": null,
    "FPAvgMiles": null,
    "FPActAvgACV": null,
    "Inv_LastImport": "2024-12-11T17:59:23.000Z",
    "Inv_LastImportby": "Jon Duncan",
    "AR_Lastimport": "2024-12-11T17:59:23.000Z",
    "AR_LastImportby": "Dana Balban",
    "DMS": "Auto Master Systems",
    "LP_NMTD": 9,
    "LP_NYTD": 140,
    "LP_NITD": 837,
    "LP_NBILLNEXT": null,
    "LP_AMTMTD": "75249.05",
    "LP_AvgMTD": "8361.01",
    "LP_AMTYTD": "1544538.70",
    "LP_AvgYTD": "11032.42",
    "LP_AMTITD": "6362712.99",
    "LP_AVGITD": "7601.81",
    "LP_BILLNEXT": null,
    "LPNPend": 0,
    "LPAPend": null,
    "LPAvgYear": 2016,
    "LPAvgMiles": 69828,
    "LPActAvgACV": "13284.61",
    "LP_NRSMTD": 4,
    "LP_NRSYTD": 36,
    "LP_NRSITD": 112,
    "LPNRPend": null,
    "LPARpend": null,
    "UsePodium": false,
    "NumVehicles": null,
    "IntDue": null,
    "CurtailDue": null,
    "TotPmtDue": null,
    "TotFLPlanBal": null,
    "SendSwapTitle": false,
    "RefiReconAllow": null,
    "HybConvMaxTerm": null,
    "HybMaxTerm": null,
    "HybridOn": null,
    "HybPercACV": null,
    "HybReconCap": null,
    "HybIntRate": null,
    "HybOrigFee": null,
    "RefiSwapReconLimit": "0.00",
    "RefiSwapFee": "50.00",
    "RefiSwapAddTerm": 9,
    "RefiSwapMaxTerm": 36,
    "ColSwapOn": true,
    "ColswapFee": "50.00",
    "ColswapAddTerm": 6,
    "ColswapAutoAddCost": "0.00",
    "ColSwapMaxTerm": 48,
    "HybAddRecon": null,
    "HybFundingDays": null,
    "DTTitleVIA": "EXML",
    "IndirectOn": null,
    "IndIntRate": null,
    "IndFundPerc": null,
    "IndMaxTerm": null,
    "IndFundingDays": null,
    "DocuSign": true,
    "ds_use_production": true,
    "ds_Dealer_firstname": "Dana",
    "ds_Dealer_lastname": "Balban",
    "ds_Dealer_email": "dana@absoluteautocredit.com",
    "ds_Dealer_Title": "General Manager",
    "ds_Dealer_Pin": "2877",
    "BHPHOn": true,
    "BHPHIntRate": "15.25",
    "BHPHFundPerc": "40.00",
    "BHPHMaxTerm": 42,
    "BHPHMaxRecon": null,
    "BHPHFundingDays": "Wednesday",
    "PFundDOMMin1": null,
    "PFundDOMMin2": null,
    "PFundDOMMax1": null,
    "PFundDOMMax2": null,
    "PLPPrintDay1": null,
    "PLPPrintDay2": null,
    "PLPDueDay1": null,
    "PLPDueDay2": null,
    "TwoFactorOn": null,
    "LL_Dealer_email": "dana@absoluteautocredit.com",
    "LL_LHPH_email": "kmckinney@lhph.com",
    "FP_Risk_rating": null,
    "FP_Risk_rating_Date": null,
    "FP_Maturity_Date": null,
    "LP_Risk_rating": "2.50",
    "LP_Risk_rating_Date": "2022-12-31",
    "LP_Maturity_Date": "2023-07-31",
    "LP_TierReview_Date": "2022-09-01",
    "Curtailment": false,
    "Curtdays1": null,
    "Curtdays2": null,
    "Curtdays3": null,
    "Curtperct1": null,
    "Curtperct2": null,
    "Curtperct3": null,
    "BorrowBase": false,
    "BBRateDate": null,
    "BBRate": null,
    "BBResidRate": "50.00",
    "BBAdvRate": "50.00",
    "BBTermMax": 48,
    "BBPAdvRate": "50.00",
    "BBPTermMax": 42,
    "BBDSSignerFirst": null,
    "BBDSSignerLast": null,
    "BBDSTitle": null,
    "BBDSEmail": null,
    "BBCReport": 104,
    "FPUCCexpDate": "2026-04-08",
    "FPFIeldExamDate": null,
    "LPUCCexpDate": "2026-04-08",
    "LPFIeldExamDate": "2021-09-20",
    "NetBilling": false,
    "ExcludeFromBilling": false,
    "ex_payoffs": false,
    "ex_refis": false,
    "ex_convers": false,
    "ex_origfee": false,
    "billing_email": null,
    "INMinRate1": null,
    "INMinRate2": null,
    "INMinRate3": null,
    "INMaxRate1": null,
    "INMaxRate2": null,
    "INMaxRate3": null,
    "INRate1": null,
    "INRate2": null,
    "INRate3": null,
    "BLMinRate1": null,
    "BLMinRate2": null,
    "BLMinRate3": null,
    "BLMaxRate1": null,
    "BLMaxRate2": null,
    "BLMaxRate3": null,
    "BLRate1": null,
    "BLRate2": null,
    "BLRate3": null,
    "geolocation": {
        "RecId": 18,
        "CompID": 124,
        "latitude": 43.2627,
        "longitude": -73.6554
    }
}
 */

const CompanyContext = createContext<CompanyContextType>({
  company_id: 0,
  company: null,
  companies: [],
  setCompany: () => {},
  loading: false,
  error: null,
});

export const CompanyProvider: React.FC<{
  children: React.ReactNode;
  selectedCompanyId?: string | null;
}> = ({ children, selectedCompanyId }) => {
  const [company, setCompany] = useState<Company | null>(null);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanies = async () => {
      // Use cached data if available (instant, no loading state)
      if (companiesCache) {
        setCompanies(companiesCache);
        return;
      }

      // Deduplicate in-flight requests
      if (!companiesFetchPromise) {
        companiesFetchPromise = CompanyService.getCompanies()
          .then(({ data }) => {
            const active = data.filter((c: Company) => c.Status === 'Active');
            companiesCache = active;
            return active;
          })
          .catch(err => {
            companiesFetchPromise = null;
            throw err;
          });
      }

      setLoading(true);
      try {
        const result = await companiesFetchPromise;
        setCompanies(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch companies');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  useEffect(() => {
    // console.log('selectedCompanyId', selectedCompanyId);
    if (selectedCompanyId && companies.length) {
      setCompany(companies.find(c => c.RecId.toString() === selectedCompanyId) || null);
      // setHeading(companies.find(c => c.RecId.toString() === selectedCompanyId)?.CompanyName || '');
    }
  }, [selectedCompanyId, companies]);

  return (
    <CompanyContext.Provider
      value={{
        company,
        companies,
        setCompany,
        loading,
        error,
        company_id: Number(selectedCompanyId) || 0,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};
